import { styled } from "@mui/styles";
import Box from "@mui/material/Box";

export const StyledTeamMemberBox = styled(Box)(({ theme }) => ({

    maxWidth: '500px',

    '& .UsersList': {
        '& .MuiCircularProgress-root': {
            margin: 'auto'
        },

        '& .UserCardContainer': {
            height: '320px',
            overflowY: 'auto',
            paddingRight: '10px',

            [theme.breakpoints.down('sm')]: {
                height: '300px',
            },
    
            '& .UserCard': {
                flexDirection: 'row',
                justifyContent: 'space-between',
                '& .UserProfile': {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '15px',
                    '& .MuiAvatar-root': {
                        width: '35px',
                        height: '35px'
                    }
                }
            },
        },


        '& .InviteByEmailStack': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px',
            
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column'
            },

            '& .InviteByEmailButtonBox': {
                minWidth: '180px',
                textAlign: 'end',
                [theme.breakpoints.down('md')]: {
                    textAlign: 'start',
                    minWidth: 'unset',
                    width: '100%'
                },
            }
        }
    }
}))